import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { SvgIcon } from 'common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';
import { PlayerModalVotes } from './player-modal-votes';
import { isFavouritePlayerSelector } from 'common/store/modules/player-awards/leaderboard/selectors';
import { playerModalSelector } from 'common/store/modules/player-awards/player-modal/selectors';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';
import { setFavouritePlayer } from 'common/store/modules/player-awards/leaderboard';

/**
 * Brownlow Player Modal - Player Details section
 *
 * @param {object} props
 * @param {string} props.playerId
 *
 * @param props.playerName
 * @returns
 */
export const PlayerModalDetails = ({ playerId, playerName }) => {
    const dispatch = useDispatch();
    const modal = useSelector(playerModalSelector);
    const isPredictor = modal.isPredictor;
    const isFavourited = useSelector((state) =>
        isFavouritePlayerSelector(state, playerId)
    );

    const compAbbr = PULSE.app.common.match.getCompAbbr(modal?.seasonPid);
    const isAFLW = compAbbr.toLowerCase() === 'aflw';

    const onPlayerFavouriteClick = () => {
        dispatch(
            setFavouritePlayer({
                id: null,
                providerId: playerId
            })
        );
    };

    return (
        <div className="player-awards-player-modal__player-details-container">
            <div className="player-awards-player-modal__player-name-container">
                <span className="player-awards-player-modal__first-name">
                    {modal.player.givenName}
                </span>
                <span className="player-awards-player-modal__last-name">
                    {modal.player.surname}
                </span>
            </div>

            <div className="player-awards-player-modal__buttons-container">
                {!isPredictor && (
                    <button
                        className="player-awards-player-modal__button"
                        data-favourite-id=""
                        data-favourite-provider-id={playerId}
                        onClick={onPlayerFavouriteClick}
                    >
                        {!playerId || !isFavourited ? (
                            <SvgIcon icon="pin-empty" className="icon" />
                        ) : (
                            <SvgIcon icon="pin-filled" className="icon" />
                        )}
                        {getTranslation('label.pinPlayer')}
                    </button>
                )}
                {playerId && (
                    <PlayerProfileLink
                        classes="player-awards-player-modal__button"
                        player={{
                            playerId: playerId,
                            firstName: modal?.player.givenName,
                            surname: modal?.player.surname
                        }}
                        isExternal={true}
                        isAFLW={isAFLW}
                    >
                        <SvgIcon
                            icon="person"
                            folder="elements"
                            subfolder="stats"
                            className="icon"
                        />
                        {getTranslation('label.stats.playerProfile')}
                    </PlayerProfileLink>
                )}
            </div>

            <PlayerModalVotes
                isPredictor={isPredictor}
                playerName={playerName}
            />
        </div>
    );
};

PlayerModalDetails.propTypes = {
    playerId: PropTypes.string.isRequired,
    playerName: PropTypes.string
};
